import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import { Col, Row, Overlay, Popover } from 'bootstrap';

import PopoverStore from 'shared/flux/stores/PopoverStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';

const popoverId = 'alignPicker';

export default React.createClass({
  mixins: [Reflux.connect(PopoverStore, 'popoverVisibility')],

  displayName: 'AlignPicker',

  propTypes: {
    type: React.PropTypes.string,
    onAlignClick: React.PropTypes.func,
  },

  getDefaultProps() {
    return {
      placement: 'bottom',
    };
  },

  render() {
    let { type } = this.props;

    if (!type) type = 'left';

    return (
      <div>
        <Icon
          ref="target"
          name={'align-' + type}
          onClick={() => PopoverActions.show(popoverId)}
        />
        <Overlay
          rootClose
          show={this.state.popoverVisibility.get(popoverId)}
          onHide={() => PopoverActions.hide(popoverId)}
          placement={this.props.placement}
          container={document.body}
          target={() => ReactDOM.findDOMNode(this.refs.target)}
        >
          {this._getPopoverNode()}
        </Overlay>
      </div>
    );
  },

  _getPopoverNode() {
    return (
      <Popover className="font-align-picker">
        <Col>
          <Row>
            {this._getFontAlignTypeNode('left')}
            {this._getFontAlignTypeNode('center')}
            {this._getFontAlignTypeNode('right')}
          </Row>
        </Col>
      </Popover>
    );
  },

  _getFontAlignTypeNode(type) {
    return (
      <Col md={8} className={'align-picker-alignment-' + type}>
        <Icon
          name={'align-' + type}
          onClick={() => this._handleOnClick(type)}
        />
      </Col>
    );
  },

  _handleOnClick(type) {
    this.props.onAlignClick(type);
    PopoverActions.hide(popoverId);
  },
});
